import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";

import { AppRedirect } from "../auth/AppRedirect";
import { useAuth } from "../auth/AuthContext";
import { ProtectedRoute } from "../auth/ProtectedRoute";
import { Header } from "../components/layout/Header";
import { MobileNavigation, Sidebar } from "../components/layout/Sidebar";

export const rootRoute = createRootRoute({
  component: RootLayout,
});

export const Route = rootRoute;

function RootLayout() {
  const location = useLocation();
  if (location.pathname === "/login" || location.pathname === "/change-password") {
    return <Outlet />;
  }

  return (
    <ProtectedRoute>
      <AuthenticatedAppShell />
    </ProtectedRoute>
  );
}

const salesAllowedPrefixes = ["/schedule", "/quotes", "/sms", "/ops"];

function isSalesAllowedPath(pathname: string) {
  return pathname === "/" || salesAllowedPrefixes.some((prefix) => pathname.startsWith(prefix));
}

function AuthenticatedAppShell() {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.role === "sales" && !isSalesAllowedPath(location.pathname)) {
    return <AppRedirect to="/" />;
  }

  return (
    <div className="min-h-screen bg-[#f8fafc] text-slate-900">
      <Header />
      <div className="flex flex-col md:flex-row">
        <Sidebar />
        <main className="min-w-0 flex-1 px-4 pb-24 pt-5 md:px-6 md:pb-6 lg:py-6">
          <div className="mx-auto max-w-7xl space-y-6">
            <Outlet />
          </div>
        </main>
      </div>
      <MobileNavigation />
    </div>
  );
}
